import BakedBreadTagDB, { BakedBreadTagEntity } from 'src/firebase/db/BakedBreadTags';

export const getBakedBreadTags = () => BakedBreadTagDB.getBakedBreadTags();
export const createBakedBreadTag = (query: BakedBreadTagEntity) => BakedBreadTagDB.create(query);
export const updateBakedBreadTags = (query: BakedBreadTagEntity) => BakedBreadTagDB.update(query);
export const deleteBakedBreadTag = (id: string) => BakedBreadTagDB.delete(id);
